import { InferOutput, number, optional } from 'valibot'

export const AmmoSchema = number()

export const OptionalAmmoSchema = optional(AmmoSchema)

export type Ammo = InferOutput<typeof AmmoSchema>

